import { computed, Ref } from 'vue'
import i18n from '@/i18n'
import { Call, Extension } from '@/types/extension'
import { getEntityAccountStatusById } from '@/composables/globalData/useEntitiesData'
import extensionStatusTypes, { callStatuses, HOLD_STATUS, isStatusIsCallStatus, Statuses } from '@/enum/redesignStatusTypes'
import { Settings } from '@/types/dashboard'

export function isCallOnHold (call: Call) {
    const status = (call.callstatus || '').toLowerCase()

    return isCallAnswered(call) && status === HOLD_STATUS
}
export function isCallAnswered (call: Call) {
    return call.answered !== 0
}

/* Types */
type ExtraCallStatusData = {
    color: string
    iconName: string
} | null

export interface ExtensionStatusData {
    text: string
    color: string
    iconName: string
    extraCallStatusData?: ExtraCallStatusData

}

export function getExtensionStatusData (extension: Extension, settings: Settings | undefined): ExtensionStatusData {
    const extensionLoginStatus = extension.representativeStatus
    const showCallStatus = settings?.showStatusTagWhenOnCall

    const hasCalls = extension.calls && extension.calls.length > 0
    const hasAnsweredCalls = hasCalls && extension.calls.some(isCallAnswered)
    const hasCallOnHold = extension.calls.some(isCallOnHold)

    const callStatus = hasCallOnHold
        ? callStatuses.HOLD
        : hasAnsweredCalls
            ? callStatuses.IN_CALL
            : hasCalls
                ? callStatuses.CALLING
                : extensionLoginStatus

    const statusType = extensionStatusTypes.value[callStatus]
    const isCallStatus = isStatusIsCallStatus(callStatus)

    const accountBreak = getEntityAccountStatusById(
        extension.accountID,
        extension.currentRepresentativeLoginStatus
    )

    const repStatusType = extensionStatusTypes.value[extension.currentRepresentativeLoginStatus]

    if (!showCallStatus && isCallStatus) {
        return {
            text: i18n.t(statusType.text) as string,
            color: statusType.color,
            iconName: statusType.icon
        }
    }

    if (accountBreak?.StatusID !== Statuses.LOGIN) {
        return {
            text: accountBreak?.Name || 'other',
            color: accountBreak?.ColorCode || '#default',
            iconName: repStatusType?.icon || 'default-icon',
            extraCallStatusData: isCallStatus ? {
                color: statusType.color,
                iconName: statusType.icon
            } : null
        }
    }

    if (isCallStatus) {
        return {
            text: i18n.t(statusType.text) as string,
            color: statusType.color,
            iconName: statusType.icon
        }
    }

    return {
        text: accountBreak?.Name || 'other',
        color: accountBreak?.ColorCode || '#default',
        iconName: repStatusType?.icon || 'default-icon'
    }
}

export default function useExtensionStatus (extension: Ref<Extension>, settings?: Ref<Settings>) {
    const extensionStatusData = computed(() =>
        getExtensionStatusData(extension.value, settings?.value)
    )
    return { extensionStatusData }
}

